const SvgDevOps1 = (props) => (
  <>
    <path fill={props.p30} d="M6 24v48l42 24 42-24V24L48 0 6 24z" />
    <path fill={props.p20} d="M102 24v48l42 24 42-24V24L144 0l-42 24z" />
    <path fill={props.p10} d="M54 104v48l42 24 42-24v-48L96 80l-42 24z" />
  </>
);

export default SvgDevOps1;
